import { render } from "./PromotionLoader.vue?vue&type=template&id=ce269ade"
import script from "./PromotionLoader.vue?vue&type=script&lang=js"
export * from "./PromotionLoader.vue?vue&type=script&lang=js"

import "./PromotionLoader.vue?vue&type=style&index=0&id=ce269ade&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__